export default __webpack_public_path__ + "static/media/pink_pawn.4c83868b.png";